import React, { useMemo } from "react";
import { IPhasesElement } from "../../../../../store/reducers/dashboard/phases/types";
import { Item } from "@elements/barsChart/BarsChart";
import BaseChartTooltip from "@modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/BaseChartTooltip";
import {
	RowWithAreaFormatter
} from "@modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/rowFormatters/RowFormatters";
import BarsChartWithLegend from "@elements/barsChartWithLegend/BarsChartWithLegend";
import { LegendRow, toggleSeries } from "@elements/Legend/Legend";
import Highcharts from 'highcharts';

type PhasesWithAreaChartProps = {
	elements: IPhasesElement[]
	chartApi: undefined | Highcharts.Chart
}

type ItemAdditionally = { dimension: string }

const Chart = BarsChartWithLegend<ItemAdditionally>

const PhasesWithAreaChart = (props: PhasesWithAreaChartProps) => {
	const { elements, chartApi } = props;

	const convertElementToChartItem = (elem: IPhasesElement): Item<ItemAdditionally> => {
		return { id: `${elem.id}`, color: elem.color, value: elem.sum, name: elem.title, dimension: elem.dimension }
	}

	const elementsToRender = useMemo(() => {
		return elements.filter(elem => elem.sum).map(convertElementToChartItem)
	}, [elements])

	const handleLegendClick = (row: LegendRow) => {
		toggleSeries(chartApi?.series, row.id)
	}

	const getTooltipText = (point: Item<ItemAdditionally>) => {
		return (
			<BaseChartTooltip
				elements={[point].map(child => ({
					id: child.id,
					color: child.color,
					name: child.name,
					area: child.value,
					dimension: child.dimension
				}))}
				cellsInRow={2}
				RowFormatter={RowWithAreaFormatter}
			/>
		)
	}

	return (
		<Chart items={elementsToRender}
			   suppressTooltipStyles
			   compareFn={(a, b) => b.value - a.value}
			   tooltipProps={{ trigger: 'hover' }}
			   onLegendClick={handleLegendClick}
			   getTooltipText={getTooltipText}
			   legendProps={{
				   height: 230,
				   headersR: [<div>Фаза</div>, <div style={{ textAlign: 'end' }}>Площадь, Га</div>]
		       }}
		/>
	)
}

export default PhasesWithAreaChart;